import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Improved error handling with actionable guidance
if (!supabaseUrl) {
  const errorMessage = [
    "❌ Missing VITE_SUPABASE_URL environment variable",
    "",
    "To fix this:",
    "1. Copy .env.example to .env",
    "2. Add your Supabase project URL to VITE_SUPABASE_URL",
    "3. Restart your development server",
    "",
    "Get your URL from: https://app.supabase.com/project/_/settings/api"
  ].join("\n");
  
  console.error(errorMessage);
  throw new Error("Missing VITE_SUPABASE_URL environment variable");
}

if (!supabaseAnonKey) {
  const errorMessage = [
    "❌ Missing VITE_SUPABASE_ANON_KEY environment variable",
    "",
    "To fix this:",
    "1. Copy .env.example to .env",
    "2. Add your Supabase anon key to VITE_SUPABASE_ANON_KEY",
    "3. Restart your development server",
    "",
    "Get your anon key from: https://app.supabase.com/project/_/settings/api"
  ].join("\n");
  
  console.error(errorMessage);
  throw new Error("Missing VITE_SUPABASE_ANON_KEY environment variable");
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

export type { Database } from "./database.types";
